<script>
  import axios from 'axios';
  import AS from '@/services/AuthenticationService';

  export default {
    all({ page, limit, q }) {
      return axios.get(`admin/requerimentos?page=${ page }&limit=${ limit }&q=${ q }`, AS.getDefaultHeaders());
    },
    pendingAnalysis() {
      return axios.get('admin/pending_analysis', AS.getDefaultHeaders());
    },
  };
</script>
